import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import {
	SuiInput,
	SuiPasswordWithPopUp,
	SuiCheckbox,
	SuiButton,
	SuiIcon,
	SuiSelect,
	SuiImageUploader,
	SuiMultiSelect,
	SuiCopyLabel,
	SuiPassword,
} from '@developers/scoro-ui';
import { popoverOptions } from '@/lib/floatingVue';

const componentsUsedInMonolithJS = {
	SuiInput,
	SuiPasswordWithPopUp,
	SuiCheckbox,
	SuiButton,
	SuiIcon,
	SuiSelect,
	SuiImageUploader,
	SuiMultiSelect,
	SuiCopyLabel,
	SuiPassword,
};

/**
 *
 */
export const renderMonolithVueComponents = (
	element: string,
	options: Record<string, unknown>
) => {
	const app = createApp({
		...options,
	});

	/**
	 * The monolith JS uses some Scoro UI Vue components without having a MFE.
	 * Eventually, we want to get rid of this, but for now, this module exposes
	 * all SUI components globally that the monolith uses.
	 */
	Object.entries(componentsUsedInMonolithJS).forEach(([name, component]) => {
		app.component(name, component);
	});

	app.use(FloatingVue, popoverOptions);

	app.mount(element);

	return app;
};
